export default "__VITE_ASSET__DhzBUubw__"